<template>
    <div class="popup">
        <van-popup :value="show" @click-overlay="close">
            <NotificationContent ref="NotificationContent" @close="close"></NotificationContent>
        </van-popup>
    </div>
</template>

<script>
import NotificationContent from './content.vue'
export default {
    name: 'Notification',
    components: { NotificationContent },
    data() {
        return {
            show: false
        }
    },
    created() { },
    methods: {
        close() {
            this.show = false
        },
        open() {
            this.show = true
            this.$nextTick(() => {
                this.$refs.NotificationContent.open()
            })
        }
    }
}
</script>

<style scoped lang="scss">
    @import '@/common/styles/viriables.scss';
.popup {
    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        &.van-popup--center {
            top: 0;
            left: 0;
            transform: translate3d(0, 0, 0);
            width: 100% !important;
            height: 100% !important;
        }
    }
}
</style>
